import { ReactComponent as TopNavigationMenuIcon } from '../../assets/images/TopNavigationMenuIcon.svg';
import { ETFIconButton, ETFIconButtonProps } from './ETFIconButton';
import { ButtonProps } from './types';

export function ETFNavMenuIconButton({ ...props }: ButtonProps & Partial<ETFIconButtonProps>) {
    return <ETFIconButton Icon={TopNavigationMenuIcon} borderRadius={50} buttonFontSize={40} {...props} />;
}
